import axios, { AxiosResponse } from 'axios';

import {
  InitiateRetryPaymentRequestData,
  InitiateRetryPaymentResponse,
  PspConnector,
  RetryPaymentStatus,
} from '@types-internal';
import { getDefaultConfig } from '@utils/configUtils';

import { makePostWithData } from './api';

export const initiateCreditCardPayment = async ({
  csrfToken,
  ...payload
}: {
  csrfToken: string;
  paymentAmount: number;
  paymentMethodNonce?: string;
  orderId: string;
  siteId: number;
  currency: string;
  connector: PspConnector;
  deviceData?: string;
}) => {
  const { retryPaymentBaseUrl } = getDefaultConfig();

  const response: AxiosResponse<RetryPaymentStatus> = await axios({
    method: 'post',
    url: `${retryPaymentBaseUrl}/payments`,
    headers: { 'X-CSRF-Token': csrfToken }, // 'X-Original-Host': domain
    data: JSON.stringify({ ...payload, paymentMethod: 'CREDIT_CARD' }),
  });
  return response;
};

export const initiatePaypalPayment = async ({
  csrfToken,
  paymentAmount,
  ...payload
}: {
  csrfToken: string;
  tokenId: string;
  paymentAmount: number;
  orderId: string;
  siteId: number;
  currency: string;
}) => {
  const { retryPaymentBaseUrl } = getDefaultConfig();
  const response: AxiosResponse<RetryPaymentStatus> = await axios({
    method: 'post',
    url: `${retryPaymentBaseUrl}/payments`,
    headers: { 'X-CSRF-Token': csrfToken }, // 'X-Original-Host': domain
    data: JSON.stringify({
      ...payload,
      paymentAmount: paymentAmount.toFixed(2).toString().replace('.', ''),
      paymentMethod: 'PAYPAL',
    }),
  });
  return response.data;
};

export const initiateApplePayPayment = async ({
  csrfToken,
  ...payload
}: {
  csrfToken: string;
  orderId: string;
  customerId: string;
  tokenId: string;
  returnUrl: string;
}) => {
  const { retryPaymentBaseUrl } = getDefaultConfig();
  const initPayment = makePostWithData<
    InitiateRetryPaymentRequestData,
    InitiateRetryPaymentResponse
  >(`${retryPaymentBaseUrl}/initiate-retry-payment`);
  const data: InitiateRetryPaymentRequestData = {
    ...payload,
    paymentMethod: 'APPLE_PAY',
  };
  return initPayment({ csrfToken, data });
};
